export default {
  title: {
    id: 'merchant_options_markets_empty_state_title',
    defaultMessage: 'Start selling in 11 markets with BackMarket!',
  },
  subtitle: {
    id: 'merchant_options_markets_empty_state_subtitle',
    defaultMessage:
      'BackMarket helps you reach your full potential by being able to sell in all this markets with little work on your side thanks to our amazing services BackCare and BackShip.',
  },
  backCareSurtitle: {
    id: 'merchant_options_markets_empty_state_backcare_surtitle',
    defaultMessage: 'International After sales services',
  },
  backCareTitle: {
    id: 'merchant_options_markets_empty_state_backcare_title',
    defaultMessage:
      "You don't know how to handle after sales in every european language?",
  },
  backCareTextIntro: {
    id: 'merchant_options_markets_empty_state_backcare_text_intro',
    defaultMessage: 'Just use BackCare!',
  },
  backCareText: {
    id: 'merchant_options_markets_empty_state_backcare_text',
    defaultMessage:
      '{intro, html} BackCare is BackMarket international after sales management service assuring all your after sales tasks for you.',
  },
  backShipSurtitle: {
    id: 'merchant_options_markets_empty_state_backship_surtitle',
    defaultMessage: 'Shipping internationally',
  },
  backShipTitle: {
    id: 'merchant_options_markets_empty_state_backship_title',
    defaultMessage: "You don't know how to ship everywhere in Europe?",
  },
  backShipTextIntro: {
    id: 'merchant_options_markets_empty_state_backship_text_intro',
    defaultMessage: 'Just use BackShip!',
  },
  backShipText: {
    id: 'merchant_options_markets_empty_state_backship_text',
    defaultMessage:
      '{intro, html} BackShip is BackMarket service to help you ship your product in all markets in one click, with all your product insured and at preferencial prices.',
  },
  learnMore: {
    id: 'merchant_options_markets_empty_state_learn_more',
    defaultMessage: 'Learn more',
  },
}
